export default "__VITE_ASSET__C3to3Pgb__"